import React, { Fragment } from 'react';
import { FileDropzone, Input, CustomIcon } from 'view/common';
import SEARCH from 'assets/img/search.svg';
import SEARCH_DARK from 'assets/img/black/search.svg';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import cx from 'classnames';
import './style.scss';

const AddAddress = ({
  toggleIndividual, individual, addressSearchValue, handleInput, dropdownVisible,
  dropdownOptions, addressList, cancel, submit, isDarkTheme,
}) => (
  <div className="modalContent">
    <h1>Add addresses manually or by<br />uploading an address file</h1>
    <div className="toggleMode" onClick={toggleIndividual}>
      <CustomIcon width="9px" height="9px" src={isDarkTheme ? ARROW_BLUE : ARROW} rotate={-90} />
      {individual
        ? <p>Add Individual Addresses</p>
        : <p>Upload Address File</p>
      }
    </div>
    {!individual
      ? (
        <Fragment>
          <Input
            inputProps={{
              type: 'text',
              name: 'addressSearchValue',
              placeholder: 'Search Address',
              value: addressSearchValue,
              onChange: handleInput,
            }}
            dropdownVisible={dropdownVisible}
            iconSrc={isDarkTheme ? SEARCH_DARK : SEARCH}
            dropdownOptions={dropdownOptions}
          />
          <div className={cx('list', { empty: addressList.length === 0 })}>
            <p>Address list empty.<br />Search address to add it to the list.</p>
          </div>
        </Fragment>
      )
      : (
        <FileDropzone>
          <p className="dropzoneEmpty">
            Drag and drop address file here<br />or select from your computer
          </p>
        </FileDropzone>
      )
    }
    <button onClick={submit} type="button" className="done">Done</button>
    <button onClick={cancel} type="button" className="cancel">Cancel</button>
  </div>
);

export { AddAddress };



// WEBPACK FOOTER //
// ./src/view/screens/ModalBodies/AddAddress.js